module.exports = __webpack_public_path__ + "img/icon-check.21ee381a.svg";